/**
 * Base URL del backend (solo origen). Debe coincidir con api.ts.
 */
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001'

/**
 * Convierte una URL de imagen del API en una URL que funcione en el entorno actual.
 * - Si la URL apunta a localhost (ej. guardada en BD desde dev), usa la API base actual (prod o dev).
 * - Si es ruta relativa (empieza con /), la convierte en URL absoluta con la API base.
 */
export function getImageUrl(url: string | undefined | null): string {
  if (!url || typeof url !== 'string') return ''
  const trimmed = url.trim()
  if (!trimmed) return ''

  try {
    // Ruta relativa: /api/uploads/images/xxx -> base + path
    if (trimmed.startsWith('/')) {
      const base = API_BASE_URL.replace(/\/$/, '')
      return `${base}${trimmed}`
    }

    // URL absoluta con localhost: reemplazar por la API base actual (para prod cuando la BD tiene URLs de dev)
    if (/^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?\//.test(trimmed)) {
      const path = new URL(trimmed).pathname + new URL(trimmed).search
      const base = API_BASE_URL.replace(/\/$/, '')
      return `${base}${path}`
    }

    return trimmed
  } catch {
    return trimmed
  }
}
